module.exports = __webpack_public_path__ + "img/no_model_available.ff75da5f.png";